// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__pdf__FrozenPdfDocumentMessage__root","icon":"CentricUI__pdf__FrozenPdfDocumentMessage__icon","text":"CentricUI__pdf__FrozenPdfDocumentMessage__text","snackbarContent":"CentricUI__pdf__FrozenPdfDocumentMessage__snackbarContent","message":"CentricUI__pdf__FrozenPdfDocumentMessage__message","heading":"CentricUI__pdf__FrozenPdfDocumentMessage__heading","subheading":"CentricUI__pdf__FrozenPdfDocumentMessage__subheading","action":"CentricUI__pdf__FrozenPdfDocumentMessage__action","buttons":"CentricUI__pdf__FrozenPdfDocumentMessage__buttons"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/pdf/FrozenPdfDocumentMessage.css
// module id = 896
// module chunks = 10